import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { TranslateModule } from '@ngx-translate/core'
import { FlexLayoutModule } from '@ngbracket/ngx-layout'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { MaterialModule } from '@shared/material/material.module'

@NgModule({
  exports: [CommonModule, FlexLayoutModule, FormsModule, MaterialModule, ReactiveFormsModule, RouterModule, TranslateModule],
})
export class VendorModule {}
